<template>
  <ListConfigPanel
    :items="Object.values(apps)"
    id-key="dynamic_app_id"
    :currently-selected-id="currentlySelectedAppId"
    icon="tdesign:app"
    :get-label="app => app.configuration.title"
    empty-text="No Apps"
    @select:item="$emit('select:app', $event)"
  />
</template>

<script>
import ListConfigPanel from "@/components/create-dashboard/ListConfigPanel.vue";

export default {
  name: "AppsConfigPanel",
  components: { ListConfigPanel },
  props: {
    apps: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    currentlySelectedAppId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ["select:app"],
};
</script>
